import {
  NgModule,
  ModuleWithProviders,
  ApplicationRef,
  ComponentFactoryResolver,
  Injector
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FileBrowserComponent } from "./components/file-browser.component";
import {
  FileBrowserService,
  FileBrowserServiceConfig
} from "./file-browser.service";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { SharedModule } from "../shared/shared.module";
import { UploadService } from "./providers/upload.service";

export function dialogServiceFactory(
  resolver: ComponentFactoryResolver,
  applicationRef: ApplicationRef,
  injector: Injector,
  options: FileBrowserServiceConfig
) {
  return new FileBrowserService(resolver, applicationRef, injector, options);
}

@NgModule({
  imports: [CommonModule, NgxSmartModalModule.forChild(), SharedModule],
  declarations: [FileBrowserComponent],
  providers: [FileBrowserService, UploadService],
  entryComponents: [FileBrowserComponent]
})
export class FileBrowserModule {
  static forRoot(config: FileBrowserServiceConfig): ModuleWithProviders {
    return {
      ngModule: FileBrowserModule,
      providers: [
        { provide: FileBrowserServiceConfig, useValue: config },
        {
          provide: FileBrowserService,
          useFactory: dialogServiceFactory,
          deps: [
            ComponentFactoryResolver,
            ApplicationRef,
            Injector,
            FileBrowserServiceConfig
          ]
        }
      ]
    };
  }
}
